var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8182 25V22.3333C22.8182 20.9188 22.2435 19.5623 21.2206 18.5621C20.1977 17.5619 18.8103 17 17.3636 17H6.45455C5.00791 17 3.62053 17.5619 2.5976 18.5621C1.57467 19.5623 1 20.9188 1 22.3333V25M31 25V22.3333C30.9991 21.1516 30.5968 20.0037 29.8564 19.0698C29.116 18.1358 28.0793 17.4688 26.9091 17.1733M21.4545 1.17333C22.6278 1.46707 23.6678 2.13427 24.4104 3.06975C25.1531 4.00523 25.5561 5.15577 25.5561 6.34C25.5561 7.52423 25.1531 8.67477 24.4104 9.61025C23.6678 10.5457 22.6278 11.2129 21.4545 11.5067M17.3636 6.33333C17.3636 9.27885 14.9216 11.6667 11.9091 11.6667C8.89663 11.6667 6.45455 9.27885 6.45455 6.33333C6.45455 3.38781 8.89663 1 11.9091 1C14.9216 1 17.3636 3.38781 17.3636 6.33333Z",
    stroke: "#0045F5",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a631698cdbf86eb067a8a6f425b40c61.svg";
export { ForwardRef as ReactComponent };